module.exports = __webpack_public_path__ + "img/lunas_lion_hat.dd11c20b.jpg";